const apiUrl = process.env.REACT_APP_API_URL;

export const addLocation = async(name) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/addLocation`;       
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify({
            name
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}




export const getLocations = async() => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/getLocations/1`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}


export const getLocation = async(id) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/getLocation/${id}`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return {  }
    }
}



export const updateLocation = async(id, name, isActive) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/updateLocation`;       
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify({
            id, name, isActive
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return {  }
    }
}
